import { render, staticRenderFns } from "./simplifyHisFee.vue?vue&type=template&id=4bd02480&scoped=true"
import script from "./simplifyHisFee.vue?vue&type=script&lang=js"
export * from "./simplifyHisFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyHisFee.vue?vue&type=style&index=0&id=4bd02480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd02480",
  null
  
)

export default component.exports